<template>
  <TagInput
    placeholder="filter by tag"
    :selected-tags="selectedTags"
    :all-tags-names="allTagsNames"
    :allow-new="false"
    class="filter-tag-input"
    autofocus
    @input="setTags"
    @clearAllTags="clearAll"
  />
</template>

<script>
  import { mapGetters } from 'vuex'
  import TagInput from '@/qlipmark-shared/components/tags/TagInput.vue'

  export default {
    name: 'TagFilterBar',
    components: {
      TagInput,
    },
    computed: {
      ...mapGetters({
        tags: 'tags/all',
      }),
      selectedTags() {
        return this.$store.state.selectedTags
      },
      allTagsNames() {
        return this.tags.map(tag => tag.name)
      },
    },
    methods: {
      setTags(tags) {
        this.$router.push({name: 'BookmarkListFiltered', params: {selectedTagsParams: tags}})
      },
      clearAll() {
        this.$store.commit('setSelectedTags', [])
      },
    }
  }
</script>

<style lang="scss" scoped>
</style>
